/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_HlsInputs */

const en_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS Manifest`)
};

const fr_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifeste HLS`)
};

const de_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS-Manifest`)
};

const it_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto HLS`)
};

const ru_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Манифест HLS`)
};

const es_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifiesto HLS`)
};

const zh_cn2_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS清单`)
};

const ja_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLSマニフェスト`)
};

const hi_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एचएलएस मैनिफेस्ट`)
};

const pt_pt2_media_import_source_hls = /** @type {(inputs: Media_Import_Source_HlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto HLS`)
};

/**
* | output |
* | --- |
* | "HLS Manifest" |
*
* @param {Media_Import_Source_HlsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_hls = /** @type {((inputs?: Media_Import_Source_HlsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_HlsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_hls(inputs)
	if (locale === "de") return de_media_import_source_hls(inputs)
	if (locale === "it") return it_media_import_source_hls(inputs)
	if (locale === "ru") return ru_media_import_source_hls(inputs)
	if (locale === "es") return es_media_import_source_hls(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_hls(inputs)
	if (locale === "ja") return ja_media_import_source_hls(inputs)
	if (locale === "hi") return hi_media_import_source_hls(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_hls(inputs)
	return en_media_import_source_hls(inputs)
});